module.exports = __webpack_public_path__ + "imgs/GanjaVacations.9ac578caa35c58263f582708cd7f8eb2.png";